import eventNearestLocation from './events/eventNearestShop';
import { trackerNameGA } from './index';

export default function () {
    window.ga(trackerNameGA(), 'event', eventNearestLocation);
}
